/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {

    loadPopup: function( popupId, popupFocus ) {
      $.magnificPopup.open( {
        items: {
          src: popupId,
        },
        type: 'inline',
        closeBtnInside: false,
        closeMarkup: '', // disables injection of the default close button
        focus: popupFocus,
        autoFocusLast: true,
        fixedContentPos: true,
        fixedBgPos: true,
        overflowY: 'auto',
        preloader: false,
        midClick: true,
        removalDelay: 300,
        mainClass: 'mfp-fade',
      }, 0 );
    },
    init: function() {
      const _this = this;
      $( document ).on( 'click', '.js-init-popup', function( e ) {
        e.preventDefault();
        const popupId = $( this ).data( 'modal' );
        let popupFocus = $( this ).data( 'modal-focus' );
        popupFocus = !$( popupFocus ).length ? '.mfp-close' : popupFocus;
        if ( popupId !== '' ) {
          _this.loadPopup( popupId, popupFocus );
        }
      } );
      $( document ).on( 'click', '.js-modal-close', function( e ) {
        e.preventDefault();
        $.magnificPopup.close();
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'modal', COMPONENT );
} )( app );
